import "./style.css";
import RightSideCars from "./components/RightSideCars.jsx";
import { fetchQuote } from "../api/api.js";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import loader from "../assets/images/loader.gif";

const ThirdStep = () => {
  const bookingData = useSelector((state) => state.booking);
  const [loading, setLoading] = useState(false); // Loader state
  const [data, setData] = useState(null); // Store API response

  // Function to fetch the quote
  const handleFetchQuote = async () => {
    if (!bookingData) {
      console.error("No booking data found in Redux store");
      return;
    }

    const requestData = {
      booster_seat: bookingData.booster || "0",
      domain_id: bookingData.domain_id,
      end: bookingData.dropoff?.address || "",
      end_lat: bookingData.dropoff?.coordinates?.lat || 0,
      end_lng: bookingData.dropoff?.coordinates?.lng || 0,
      infant_seat: bookingData.infant || "0",
      luggage: bookingData.luggage || "0",
      passengers: bookingData.passenger || "1",
      pick_date: bookingData.date || "",
      pick_time: bookingData.time || "",
      regular_seat: bookingData.regular || "0",
      service_type: bookingData.service_type || "",
      start: bookingData.pickup?.address || "",
      start_lat: bookingData.pickup?.coordinates?.lat || 0,
      start_lng: bookingData.pickup?.coordinates?.lng || 0,
    };

    try {
      setLoading(true); 
      const response = await fetchQuote(requestData);
      setData(response.data);
      console.log("Quote Response:", response);
    } catch (error) {
      console.error("Error fetching quote:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // Call API when component mounts
  useEffect(() => {
    handleFetchQuote();
  }, []);

  return (
    <div className={`container-fluid dim-bg main-quote-page ${loading ? "loading-bg" : ""}`}>
      {loading && (
        <div className="full-page-loader">
          <img src={loader} width={'200px'} alt="Loading..." />
        </div>
      )}
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="vehicle-selection-container">
            {!loading && <RightSideCars data={data} />}
          </div>
        </div>
      </div>
      
      <style>{`
        .vehicle-selection-container {
          background: #eff0f3;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          margin: 20px 0;
        }
        
        .dim-bg {
          background: #f5f5f5;
          min-height: 100vh;
          padding: 20px 0;
        }

        .payment-options {
          display: flex;
          justify-content: space-between;
          gap: 10px;
          margin: 15px 0;
        }

        .payment-option {
          flex: 1;
          border: 2px solid #ddd;
          border-radius: 8px;
          padding: 10px;
          text-align: center;
          background-color: #f9f9f9;
          position: relative;
        }

        .payment-option .payment-label {
          font-weight: 600;
          font-size: 14px;
          margin-bottom: 5px;
          color: #333;
        }

        .payment-option .payment-price {
          font-weight: 700;
          font-size: 18px;
          color: #188038;
          margin-bottom: 0;
        }

        .payment-option .payment-discount {
          position: absolute;
          top: -10px;
          right: -10px;
          font-size: 15px;
          font-weight: 700;
          color: white;
          background-color: #d32f2f;
          border-radius: 4px;
          padding: 3px 7px;
        }
        
        @media screen and (max-width: 480px) {
          .payment-option .payment-discount {
            top: -25%;
            right: 20%;
          }
        }

        .fleet-features {
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding: 10px;
          background-color: #188038;
          color: white;
          border-radius: 4px;
          margin-top: 15px;
        }

        .feature-box {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 14px;
        }

        .feature-box svg {
          font-size: 24px;
          margin-bottom: 5px;
        }

        .fleet-description {
          font-size: 13px;
          color: #666;
          margin: 5px 0 10px;
          min-height: 30px; /* Reserve space even if empty */
        }

        .option-content {
          display: flex;
          flex-direction: column; /* Stack image and fare vertically */
          align-items: center; /* Center items horizontally */
          gap: 15px;
          flex-grow: 1;
          text-align: center; /* Center text */
        }

        .option-content img {
          width: 80%; /* Make image larger */
          max-width: 220px;
          height: auto;
          margin-bottom: 10px;
        }

        .option-fares {
          width: 100%;
        }

        .total-payable {
          display: flex;
          justify-content: center; /* Center the total fare */
          align-items: center;
          padding: 12px 0;
          font-size: 22px; /* Make fare text larger */
          font-weight: bold;
          color: #188038;
          border-top: 1px solid #eee;
          margin-top: 15px;
        }

        .total-payable span {
          margin-right: 10px; /* Space between 'Total Payable' and price */
          font-size: 16px;
          color: #333;
        }
      `}</style>
    </div>
  );
  
};

export default ThirdStep;
